export class UpdateNetworkConnected {
  static readonly type = '[Sync] Update Network Connected';
  constructor(public networkConnected: boolean) {}
}
